module.exports = __webpack_public_path__ + "img/regular-pop-quiz.f9f9f250.svg";